import { requireBaseBadgesPermissions } from '../../../../backend/features/badges/shared';
import { BadgeList } from '../../../../ui/features/badge-management/components/BadgeList/BadgeList';
import { BadgeTemplateList } from '../../../../ui/features/badge-management/components/BadgeTemplateList';
import { homeTabNames, searchParamKeyTab } from '../../../../ui/features/badge-management/utils/manageBadgesRoutes';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import { Box, Tab, Tabs } from '@mui/material';
import React from 'react';
import { useSearchParams } from 'react-router';
import { BadgePageHeader } from './BadgePageHeader';
export const ManageBadgesPage = () => {
    const { tabs, selectedTab, handleTabChange } = useManageBadgesTabs();
    return (React.createElement(React.Fragment, null,
        React.createElement(BadgePageHeader, null),
        React.createElement(Box, { display: 'flex', flexDirection: 'column' },
            React.createElement(Box, { sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    px: 4,
                    borderBottom: 1,
                    borderColor: 'divider',
                    boxShadow: 1,
                    zIndex: 1,
                } },
                React.createElement(Tabs, { variant: 'scrollable', value: selectedTab, onChange: handleTabChange }, tabs.map((tab) => (React.createElement(Tab, { key: tab.value, label: tab.label, value: tab.value, "data-test": `tab-${tab.value}` }))))),
            React.createElement(Box, { sx: { px: 4, py: 3, backgroundColor: themeColors.background } },
                React.createElement(Box, { display: 'flex', flexDirection: 'column', gap: 1 },
                    selectedTab === 'manage-badges' && React.createElement(BadgeList, null),
                    selectedTab === 'badge-templates' && React.createElement(BadgeTemplateList, null))))));
};
function useManageBadgesTabs() {
    var _a;
    const userState = useUserState();
    const { t } = useBadgingTranslation();
    const [searchParams, setSearchParams] = useSearchParams();
    const tabs = [];
    tabs.push({ value: 'manage-badges', label: t('badges.badgesPanel.tabNameManageBadges') });
    if (requireBaseBadgesPermissions(userState)) {
        tabs.push({ value: 'badge-templates', label: t('badges.badgesPanel.tabNameBadgeTemplates') });
    }
    const selectedTab = (_a = homeTabNames.find((tabName) => tabName === searchParams.get(searchParamKeyTab))) !== null && _a !== void 0 ? _a : tabs[0].value;
    const handleTabChange = (_, value) => {
        setSearchParams((prevValues) => {
            prevValues.set(searchParamKeyTab, value);
            return prevValues;
        }, { replace: true });
    };
    return {
        tabs,
        selectedTab,
        handleTabChange,
    };
}
